import React, { FC } from 'react';

import { Center, HStack, Stack, Text } from '@chakra-ui/react';
import { colorOpacity, customTheme } from 'theme';

// Moved out of DataGroupOverviewTables (one component per file) and given
// `icon` + `color` props so each section header shows a tinted icon badge.
interface Props {
  title: string;
  count: number;
  icon?: React.ReactNode;
  color?: string;
  h?: number;
  children: React.ReactNode;
}

const sectionStyles = {
  border: '1px solid',
  borderColor: customTheme.colors.gray['100'],
  borderRadius: 6,
  py: 4,
  px: 2,
};

export const TableSection: FC<Props> = props => {
  const {
    title,
    count,
    icon,
    color = customTheme.colors.primary,
    h = 72,
    children,
  } = props;
  return (
    <Stack h={h} spacing={4} {...sectionStyles}>
      <HStack px={2} spacing={3}>
        {icon && (
          <Center
            boxSize={8}
            p={1.5}
            borderRadius="lg"
            color={color}
            bg={colorOpacity(color, 0.2)}
          >
            {icon}
          </Center>
        )}
        <Text fontSize="lg" fontWeight={500}>
          {title}
        </Text>
        <Center
          minW={6}
          h={6}
          px={1.5}
          borderRadius="full"
          bg="purple.100"
          color="primary"
          fontSize="sm"
        >
          {count}
        </Center>
      </HStack>
      {children}
    </Stack>
  );
};
